import { GET_VISITED_PROFILE, SET_FOLLOW, SET_VISITED_PROFILE } from "./constants";

export function getVisitedProfile(username, cbSuccess) {
  return {
    type: GET_VISITED_PROFILE,
    username,
    cbSuccess
  };
}
export function setFollow(mode, username) {
  return {
    type: SET_FOLLOW,
    mode,
    username,
  }
}
export function setVisitedProfile(data){
    return {
        type: SET_VISITED_PROFILE,
        data,
    }
}
